/*global
gsap,
ScrollTrigger,
Swiper,
Sticky,
jQuery,
Fancybox,
lottie
 */
/*eslint no-undef: "error"*/
/*eslint-env browser*/

// Make jQuery available if needed
const $j = jQuery.noConflict();

//// Site functions ////

// Hide me show me header
function headerHideShow() {
  let didScroll;
  let lastScrollTop = 0;

  const navbar = document.querySelector("#site-header");

  const delta = 5;

  const navbarHeight = navbar.offsetHeight;

  window.addEventListener("scroll", () => {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      4;
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    let st = window.pageYOffset;

    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > navbarHeight * 2) {
      // Scroll Down
      navbar.classList.remove("nav-down");
      navbar.classList.add("nav-up");
    } else {
      // Scroll Up
      if (st + window.innerHeight < document.body.clientHeight) {
        navbar.classList.remove("nav-up");
        navbar.classList.add("nav-down");
      }
    }

    lastScrollTop = st;
  }

  // Change header on scroll
  function navScroll() {
    let $sticky = $j("#site-header"),
      $scroll = $j(window).scrollTop();

    if ($scroll > navbarHeight) {
      if (!$sticky.hasClass("scrolled")) {
        $sticky.addClass("scrolled");
      }
    } else {
      $sticky.removeClass("scrolled");
    }
  }
  navScroll();
  $j(window).on("scroll resize", navScroll);
}

function burgerMenu() {
  const navOpen = document.querySelector("#nav-open");
  const navContainer = document.querySelector("#nav-mobile");
  const burger = document.querySelector("#nav-icon");
  const menuItems = document.querySelectorAll("#menu-main__mobile>li");
  const mobMenuFooter = document.querySelector(".mobile-navbar__footer-wrap");
  const siteHeader = document.querySelector("#site-header");

  const reduceMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function openMobileMenu() {
    navContainer.hidden = false;

    gsap.to(navContainer, {
      autoAlpha: 1,
      duration: reduceMotion() ? 0 : 0.3,
    });

    if (!reduceMotion()) {
      gsap.from(menuItems, {
        autoAlpha: 0,
        yPercent: 100,
        ease: "power1.out",
        stagger: 0.05,
      });

      gsap.from(mobMenuFooter, {
        autoAlpha: 0,
        yPercent: 100,
        ease: "power1.out",
        stagger: 0.05,
        delay: 0.3,
      });
    }

    document.documentElement.classList.add("noscroll");
    document.querySelector(".navbar-brand").classList.add("menu-open");
    navOpen.classList.add("nav-open");
    navOpen.setAttribute("aria-expanded", "true");
    navOpen.setAttribute("aria-label", "Close menu");
    burger.classList.add("open");
    siteHeader.classList.add("nav-open");

    // Move focus into the panel — the first root-level link — rather than
    // leaving it on the trigger button while an unrelated part of the page
    // sits underneath it.
    const firstLink = navContainer.querySelector("#menu-main__mobile > li:first-child > a");
    if (firstLink) firstLink.focus();
  }

  // Keeps Tab/Shift+Tab cycling between the close button and the panel's
  // own focusable elements while the menu is open, instead of walking back
  // into the page content sitting behind the full-screen overlay.
  function trapFocus(event) {
    if (event.key !== "Tab" || !navOpen.classList.contains("nav-open")) return;

    const focusable = [
      navOpen,
      ...navContainer.querySelectorAll("a[href], button:not([disabled])"),
    ];
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeMobileMenu() {
    gsap.to(navContainer, {
      autoAlpha: 0,
      duration: reduceMotion() ? 0 : 0.3,
      onComplete: () => {
        navContainer.hidden = true;
      },
    });
    document.documentElement.classList.remove("noscroll");
    document.querySelector(".navbar-brand").classList.remove("menu-open");
    navOpen.classList.remove("nav-open");
    navOpen.setAttribute("aria-expanded", "false");
    navOpen.setAttribute("aria-label", "Open menu");
    burger.classList.remove("open");
    siteHeader.classList.remove("nav-open");

    // Always land back on the root list next time the menu opens, whatever
    // screen (if any) was showing when it closed.
    if (typeof navContainer.resetMobileNavScreens === "function") {
      navContainer.resetMobileNavScreens();
    }
  }

  navOpen.addEventListener("click", function () {
    if (!navOpen.classList.contains("nav-open")) {
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !navOpen.classList.contains("nav-open")) {
      return;
    }
    // Layered escape: if a drill-down screen inside the mobile nav is open,
    // let mobileNavDrilldown()'s own Escape handler step back one level
    // first, rather than also closing the whole mobile menu overlay on the
    // same keypress.
    if (document.querySelector('#menu-main__mobile [aria-expanded="true"]')) {
      return;
    }
    closeMobileMenu();
    navOpen.focus();
  });

  document.addEventListener("keydown", trapFocus);

  // Crossing back into the desktop breakpoint with the mobile menu open
  // would otherwise leave the body scroll-locked and the burger stuck in
  // its "open" state under the (now hidden) mobile nav.
  window.addEventListener("resize", function () {
    if (window.innerWidth >= 992 && navOpen.classList.contains("nav-open")) {
      closeMobileMenu();
    }
  });
}

// Mega menu submenu icons: animated Lottie icons, reusing the same
// lottie-web instance/asset machinery as the flx-services cards
// (createLottieIcon(), further down this file). Unlike a services card,
// which sits in normal page flow, a submenu icon lives inside a panel that
// starts `hidden` — so relying on IntersectionObserver at page load isn't
// reliable (a display:none element never reports as intersecting). Instead
// each panel's icons are instantiated and auto-played once, the first time
// that specific panel is actually opened (called from navDesktop()'s
// showPanel() and mobileNavDrilldown()'s openScreen() below) — never at
// page load, and never again on subsequent opens of the same panel. Hover/focus
// replay (wired up the first time an icon is activated) always works
// regardless of that "seen" state, exactly like the services cards.
const megaMenuLottieAnimations = new WeakMap();

function activateMegaMenuLottieIcons(panel) {
  if (!panel) {
    return;
  }

  const reduceMotion = lottiePrefersReducedMotion();
  const icons = panel.querySelectorAll(".js-lottie-icon");

  icons.forEach((iconEl) => {
    if (!iconEl.hasAttribute("data-lottie-ready")) {
      const anim = createLottieIcon(iconEl, reduceMotion);

      if (!anim) {
        return;
      }

      megaMenuLottieAnimations.set(iconEl, anim);

      if (!reduceMotion) {
        const item = iconEl.closest(
          ".mega-menu__card, .mega-menu-mobile__link"
        );

        if (item) {
          const replay = () => anim.goToAndPlay(0, true);
          item.addEventListener("mouseenter", replay);
          item.addEventListener("focusin", replay);
        }
      }
    }

    if (reduceMotion || iconEl.hasAttribute("data-lottie-seen")) {
      return;
    }

    const anim = megaMenuLottieAnimations.get(iconEl);

    if (anim) {
      iconEl.setAttribute("data-lottie-seen", "");
      anim.goToAndPlay(0, true);
    }
  });
}

function siteSearch() {
  // Shared by the desktop navbar's magnifier (#search-open) and the mobile
  // nav's own "Search" pill (#search-open-mobile, see header.php) — both
  // open the same modal.
  const searchOpenTriggers = document.querySelectorAll(".js-open-search");
  const searchClose = document.querySelector("#search-close");
  const searchModal = document.querySelector("#site-search");

  searchOpenTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();

      // Opening search from inside the mobile nav closes it first — two
      // full-screen overlays stacked on top of each other otherwise.
      const navOpen = document.querySelector("#nav-open");
      if (navOpen && navOpen.classList.contains("nav-open")) {
        navOpen.click();
      }

      // Make the popup focusable (visibility: visible) and focus the field
      // synchronously, still inside the click — so the user can type
      // straight away, and iOS opens the keyboard (it ignores focus() calls
      // made later, e.g. after the fade). The fade itself carries on as before.
      gsap.set(searchModal, { visibility: "visible" });

      const searchInput = searchModal.querySelector(
        'input[type="search"], input[type="text"]'
      );
      if (searchInput) {
        searchInput.focus({ preventScroll: true });
      }

      gsap.to(searchModal, {
        autoAlpha: 1,
      });
    });
  });

  searchClose.addEventListener("click", function () {
    gsap.to(searchModal, {
      autoAlpha: 0,
    });
  });

  // Click on the dimmed backdrop (not the panel itself) closes the popup
  // the same way #search-close does.
  searchModal.addEventListener("click", function (e) {
    if (e.target === searchModal) {
      gsap.to(searchModal, {
        autoAlpha: 0,
      });
    }
  });

  // On every other page, searching from this popup navigates to the search
  // results page, which closes the popup for free (fresh page load). On
  // the results page itself, Search & Filter Pro already has its
  // #search-results container on the page, so it updates that in place via
  // AJAX instead of navigating — nothing else ever closes the popup in
  // that case, so watch the container and close it once new results land.
  const searchResults = document.querySelector("#search-results");

  if (searchResults) {
    const searchResultsObserver = new MutationObserver(function () {
      gsap.to(searchModal, {
        autoAlpha: 0,
      });
    });

    searchResultsObserver.observe(searchResults, {
      childList: true,
      subtree: true,
    });
  }
}

// Desktop mega menu: label link + caret trigger(s) + floating panel(s) +
// backdrop. Only "What we do" has a mega menu today, but this is written
// generically against any
// #menu-main__desktop > li.menu-item-has-children > .nav-trigger-caret
// so it keeps working (and keeps enforcing "only one open at a time") if a
// second mega menu trigger is ever added. The item's own <a> label is a
// normal clickthrough link (no JS involved); only the separate caret button
// opens/closes the panel, since hover already covers the common desktop case.
function navDesktop() {
  const nav = document.querySelector("#menu-main__desktop");
  if (!nav) return;

  const triggers = Array.from(
    nav.querySelectorAll(
      ":scope > li.menu-item-has-children > .nav-trigger-caret"
    )
  );
  if (!triggers.length) return;

  const siteHeader = document.querySelector("#site-header");
  const HOVER_OPEN_DELAY = 100;
  const HOVER_CLOSE_DELAY = 250;
  const CLOSE_TRANSITION_MS = 250;

  let openTrigger = null;
  let openTimer = null;
  let closeTimer = null;

  const panelFor = (trigger) =>
    document.getElementById(trigger.getAttribute("aria-controls"));

  function showPanel(trigger, panel) {
    clearTimeout(closeTimer);
    panel.hidden = false;
    // Force layout so the opacity/transform transition runs from the hidden state.
    void panel.offsetHeight;
    panel.classList.add("open");
    trigger.setAttribute("aria-expanded", "true");
    document.body.classList.add("mega-menu-open");
    if (siteHeader) siteHeader.classList.add("mega-open");
    openTrigger = trigger;
    activateMegaMenuLottieIcons(panel);
  }

  function hidePanel(trigger, panel, immediate) {
    trigger.setAttribute("aria-expanded", "false");
    panel.classList.remove("open");
    document.body.classList.remove("mega-menu-open");
    if (siteHeader) siteHeader.classList.remove("mega-open");

    clearTimeout(closeTimer);
    if (immediate) {
      panel.hidden = true;
    } else {
      closeTimer = setTimeout(() => {
        panel.hidden = true;
      }, CLOSE_TRANSITION_MS);
    }

    if (openTrigger === trigger) {
      openTrigger = null;
    }
  }

  function closeAll(immediate) {
    triggers.forEach((trigger) => {
      const panel = panelFor(trigger);
      if (panel && !panel.hidden) {
        hidePanel(trigger, panel, immediate);
      }
    });
  }

  triggers.forEach((trigger) => {
    const panel = panelFor(trigger);
    if (!panel) return;
    // Hover is bound to the whole <li> (label link + caret), not just the
    // caret button, so hovering the visible label text also opens the panel
    // — clicking the caret is only required for touch/keyboard users.
    const li = trigger.closest("li") || trigger;

    trigger.addEventListener("click", () => {
      const isOpen = trigger.getAttribute("aria-expanded") === "true";
      clearTimeout(openTimer);
      closeAll(true);
      if (!isOpen) {
        showPanel(trigger, panel);
      }
    });

    const scheduleOpen = () => {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(() => {
        if (trigger.getAttribute("aria-expanded") !== "true") {
          closeAll(true);
          showPanel(trigger, panel);
        }
      }, HOVER_OPEN_DELAY);
    };

    const scheduleClose = () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        hidePanel(trigger, panel);
      }, HOVER_CLOSE_DELAY);
    };

    // Hover-intent: stay open while the pointer travels between the item
    // (label + caret) and the panel (there is a gap between them), close
    // after a short delay once it leaves both.
    li.addEventListener("mouseenter", scheduleOpen);
    li.addEventListener("mouseleave", scheduleClose);
    panel.addEventListener("mouseenter", () => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    });
    panel.addEventListener("mouseleave", scheduleClose);

    // Close after a link inside the panel is activated.
    panel.addEventListener("click", (event) => {
      if (event.target.closest("a")) {
        closeAll();
      }
    });
  });

  // Escape closes the open menu and restores focus to its trigger.
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && openTrigger) {
      const trigger = openTrigger;
      closeAll();
      trigger.focus();
    }
  });

  // Click outside the item (label + caret) or panel closes the open menu.
  document.addEventListener("click", (event) => {
    if (!openTrigger) return;
    const panel = panelFor(openTrigger);
    const li = openTrigger.closest("li");
    if (
      (li && li.contains(event.target)) ||
      (panel && panel.contains(event.target))
    ) {
      return;
    }
    closeAll();
  });

  // Tabbing focus out of the item (label + caret) or panel closes the open menu.
  document.addEventListener("focusin", (event) => {
    if (!openTrigger) return;
    const panel = panelFor(openTrigger);
    const li = openTrigger.closest("li");
    if (
      (li && li.contains(event.target)) ||
      (panel && panel.contains(event.target))
    ) {
      return;
    }
    closeAll(true);
  });

  // Below the desktop breakpoint the mega menu markup is hidden in favour of
  // the mobile accordion — make sure open state doesn't linger across resize.
  window.addEventListener("resize", () => {
    if (window.innerWidth < 992) {
      closeAll(true);
    }
  });
}

// Mobile nav "drill-down": tapping a root item with children (ACF mega menu
// content OR a conventional WordPress submenu — two distinct data sources,
// see inc/nav-primary-menu.php) replaces the root list with a dedicated
// full-screen screen for that item — title + "Back", a muted link back to
// the item's own page, then its content — matching Figma node 3386:894,
// rather than expanding an accordion in place. Both trigger shapes already
// carry aria-expanded + aria-controls wired to their panel's id by the
// walker (a standalone .mobile-nav-trigger button carrying its own title
// text + data-href for mega items, the <a> itself for conventional ones),
// so both are handled the same way here.
function mobileNavDrilldown() {
  const root = document.querySelector("#menu-main__mobile");
  const wrapper = document.querySelector(".navbar-menu__mobile-wrapper");
  const ctas = document.querySelector(".navbar-menu__mobile-ctas");
  if (!root || !wrapper) return;

  const triggers = Array.from(
    root.querySelectorAll(
      ":scope > li.menu-item-has-children > .mobile-nav-trigger[aria-controls], :scope > li.menu-item-has-children > a[aria-expanded][aria-controls]"
    )
  );
  if (!triggers.length) return;

  const reduceMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const backIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" viewBox="0 0 19 11" fill="none" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.231125 4.46525L4.69638 -2.9586e-06L5.8125 1.11611L1.9053 5.02331L5.8125 8.93051L4.69638 10.0466L0.231125 5.58137C0.0831479 5.43335 1.90175e-05 5.23262 1.90358e-05 5.02331C1.90541e-05 4.81401 0.083148 4.61328 0.231125 4.46525Z" fill="#2C2E3E"/><line x1="1.50586" y1="4.94534" x2="18.8513" y2="4.94535" stroke="#2C2E3E" stroke-width="1.5"/></svg>';

  const screens = [];

  triggers.forEach((trigger) => {
    const panel = document.getElementById(trigger.getAttribute("aria-controls"));
    const li = trigger.closest("li");
    if (!panel || !li) return;

    // Mega trigger: the <button> itself carries the title text, with the
    // item's own URL riding along in data-href (there's no separate label
    // <a> to read it from — see inc/nav-primary-menu.php). Conventional
    // trigger: the <a> itself is both the label and trigger, href and all.
    const isMegaTrigger = trigger.tagName === "BUTTON";
    const title = trigger.textContent.trim();
    const href = isMegaTrigger ? trigger.getAttribute("data-href") : trigger.getAttribute("href");

    // The panel itself (.mega-menu-mobile <div>, or a conventional
    // <ul class="sub-menu">) becomes this screen's content — it's wrapped
    // in its own <div>, rather than having the head/discover elements
    // injected directly into it, since a <ul> can only validly contain
    // <li> children.
    const screen = document.createElement("div");
    screen.className = "mobile-nav__screen";
    screen.hidden = true;

    const head = document.createElement("div");
    head.className = "mobile-nav__screen-head";

    const titleEl = document.createElement("span");
    titleEl.className = "mobile-nav__screen-title";
    titleEl.setAttribute("tabindex", "-1");
    titleEl.textContent = title;

    const backBtn = document.createElement("button");
    backBtn.type = "button";
    backBtn.className = "mobile-nav__back";
    backBtn.innerHTML =
      '<span class="mobile-nav__back-icon">' + backIcon + "</span><span>Back</span>";

    head.appendChild(titleEl);
    head.appendChild(backBtn);
    screen.appendChild(head);

    if (href && href !== "#0" && href !== "#") {
      const discover = document.createElement("a");
      discover.className = "mobile-nav__discover";
      discover.href = href;

      const discoverLabel = document.createElement("span");
      discoverLabel.className = "mobile-nav__discover-label";
      discoverLabel.textContent = "Discover " + title.toLowerCase();
      discover.appendChild(discoverLabel);

      screen.appendChild(discover);
    }

    panel.hidden = false;
    panel.classList.remove("open");
    screen.appendChild(panel);

    // Insert the screen as a sibling of the root list, sitting where the
    // panel used to live inside its <li> — it needs to be hidden/shown
    // independently of #menu-main__mobile, which nesting couldn't do.
    wrapper.insertBefore(screen, ctas);

    function openScreen() {
      screens.forEach((s) => {
        if (s.screen !== screen && !s.screen.hidden) s.close();
      });

      root.hidden = true;
      screen.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      activateMegaMenuLottieIcons(panel);

      if (!reduceMotion()) {
        gsap.fromTo(
          screen,
          { autoAlpha: 0, x: 24 },
          { autoAlpha: 1, x: 0, duration: 0.3, ease: "power1.out" }
        );
      }

      titleEl.focus();
    }

    function closeScreen(returnFocus) {
      screen.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      root.hidden = false;

      if (!reduceMotion()) {
        gsap.fromTo(
          root,
          { autoAlpha: 0, x: -24 },
          { autoAlpha: 1, x: 0, duration: 0.3, ease: "power1.out" }
        );
      }

      if (returnFocus) trigger.focus();
    }

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openScreen();
    });

    backBtn.addEventListener("click", () => closeScreen(true));

    screens.push({ trigger, screen, close: closeScreen });
  });

  // Escape steps back one level (handled here) rather than closing the
  // whole overlay in one go — burgerMenu()'s own Escape handler checks for
  // an open [aria-expanded="true"] trigger first and defers to this.
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const active = screens.find((s) => s.trigger.getAttribute("aria-expanded") === "true");
    if (active) active.close(true);
  });

  // Exposed so burgerMenu() can reset to the root screen whenever the whole
  // mobile nav closes (X, Escape, or resizing past the mobile breakpoint),
  // so reopening it never lands mid-drill-down.
  document.querySelector("#nav-mobile").resetMobileNavScreens = function () {
    screens.forEach((s) => {
      s.screen.hidden = true;
      s.trigger.setAttribute("aria-expanded", "false");
    });
    root.hidden = false;
  };
}

// Accordion
function flxAccordion() {
  const accordionBlocks = document.querySelectorAll(".flx-accordion");

  accordionBlocks.forEach((accordionBlock) => {
    const accordions = accordionBlock.querySelectorAll(".flx-accordion__row");
    const allContent = accordionBlock.querySelectorAll(
      ".flx-accordion__row-content"
    );

    $j(allContent).hide();

    if (typeof accordions != "undefined" && accordions != null) {
      const openAccordion = (accordion) => {
        const heading = accordion.querySelector(".flx-accordion__row-heading");
        const content = accordion.querySelector(".flx-accordion__row-content");
        const icon = accordion.querySelector(".flx-accordion__row-icon");
        heading.classList.add("active");
        content.classList.add("open");
        icon.classList.add("active");
        $j(content)
          .css("opacity", 0)
          .slideDown("fast")
          .animate({ opacity: 1 }, { queue: false, duration: "fast" });
      };

      const closeAccordion = (accordion) => {
        const heading = accordion.querySelector(".flx-accordion__row-heading");
        const content = accordion.querySelector(".flx-accordion__row-content");
        const icon = accordion.querySelector(".flx-accordion__row-icon");
        heading.classList.remove("active");
        content.classList.remove("open");
        icon.classList.remove("active");
        $j(content)
          .css("opacity", 1)
          .slideUp("fast")
          .animate({ opacity: 0 }, { queue: false, duration: "fast" });
      };

      accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".flx-accordion__row-heading");
        const content = accordion.querySelector(".flx-accordion__row-content");

        intro.onclick = () => {
          if (content.classList.contains("open")) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(accordion);
          }
        };
      });
    } else {
      return;
    }
  });
}

// Accordion tabs
function flxAccordionTabs() {
  const accordionTabBlocks = document.querySelectorAll(".flx-accordion-tabs");

  accordionTabBlocks.forEach((accordionTabBlock) => {
    const accordions = accordionTabBlock.querySelectorAll(".tab-content");
    const allContent = accordionTabBlock.querySelectorAll(".tab-content");

    $j("[data-tab]").on("click", function (e) {
      // $j(this).parent().siblings('[data-content=' + $j(this).data('tab') + ']').siblings('[data-content]').hasClass('.active').show();
      $j(this).addClass("active").siblings("[data-tab]").removeClass("active");
      $j(this)
        .parent()
        .siblings("[data-content=" + $j(this).data("tab") + "]")
        .fadeIn()
        .addClass("active");
      $j(this)
        .parent()
        .siblings("[data-content=" + $j(this).data("tab") + "]")
        .siblings("[data-content]")
        .hide()
        .removeClass("active");
      e.preventDefault();
      gsapAnimateScroll();
    });

    // // Source - https://stackoverflow.com/a
    // // Posted by gaetanoM, modified by community. See post 'Timeline' for change history
    // // Retrieved 2025-12-10, License - CC BY-SA 4.0

    // const tabTriggerBtns = accordionTabBlock.querySelectorAll('.tab-link');

    // tabTriggerBtns.forEach(function(tabTriggerBtn, index){
    //     tabTriggerBtn.addEventListener('click', function(){
    //         var currentTabData = accordionTabBlock.querySelector('.tab-content[data-tab-content="' + this.dataset.tabTrigger + '"]');

    //         // remove classess
    //         accordionTabBlock.querySelector('.tab-content.is-open').classList.remove('is-open');
    //         accordionTabBlock.querySelector('.tab-link.is-active').classList.remove('is-active');

    //         // add classes
    //         currentTabData.classList.add('is-open');
    //         this.classList.add('is-active');

    //     });
    // });
  });
}

// Products (tabbed flexible block)
function flxProducts() {
  const productBlocks = document.querySelectorAll(".flx-products");

  productBlocks.forEach((productBlock) => {
    const tabs = Array.from(
      productBlock.querySelectorAll(".flx-products__tab")
    );
    const panels = Array.from(
      productBlock.querySelectorAll(".flx-products__panel")
    );
    const select = productBlock.querySelector(".flx-products__select");

    if (!tabs.length || !panels.length) {
      return;
    }

    const activateTab = (index) => {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle("active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle("active", isActive);
        if (isActive) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });

      if (select && select.selectedIndex !== index) {
        select.selectedIndex = index;
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activateTab(index));

      tab.addEventListener("keydown", (e) => {
        let newIndex = null;

        switch (e.key) {
          case "ArrowRight":
          case "ArrowDown":
            newIndex = (index + 1) % tabs.length;
            break;
          case "ArrowLeft":
          case "ArrowUp":
            newIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case "Home":
            newIndex = 0;
            break;
          case "End":
            newIndex = tabs.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        tabs[newIndex].focus();
        activateTab(newIndex);
      });
    });

    if (select) {
      select.addEventListener("change", () => {
        activateTab(select.selectedIndex);
      });
    }
  });
}

// FAQs (accessible accordion) — also drives the Agenda block
// (.flx-agenda / .flx-agenda__trigger), which reuses this same
// button[aria-expanded] + hidden-panel behaviour under a different layout.
function flxFaqs() {
  const faqBlocks = document.querySelectorAll(".flx-faqs, .flx-agenda");
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  faqBlocks.forEach((faqBlock) => {
    const triggers = faqBlock.querySelectorAll(
      ".flx-faqs__trigger, .flx-agenda__trigger"
    );

    const closeItem = (trigger) => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      trigger.setAttribute("aria-expanded", "false");

      if (!panel) {
        return;
      }

      if (prefersReducedMotion) {
        panel.hidden = true;
        return;
      }

      $j(panel)
        .stop(true, true)
        .slideUp("fast", () => {
          panel.hidden = true;
        });
    };

    const openItem = (trigger) => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;
      trigger.setAttribute("aria-expanded", "true");

      if (!panel) {
        return;
      }

      panel.hidden = false;

      if (prefersReducedMotion) {
        return;
      }

      $j(panel).css("display", "none").stop(true, true).slideDown("fast");
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        triggers.forEach((otherTrigger) => {
          if (
            otherTrigger !== trigger &&
            otherTrigger.getAttribute("aria-expanded") === "true"
          ) {
            closeItem(otherTrigger);
          }
        });

        if (isOpen) {
          closeItem(trigger);
        } else {
          openItem(trigger);
        }
      });
    });
  });
}

// Smooth scroll
function smoothScroll() {
  const stickyAnchors = $j(".flx-anchor-links").outerHeight();
  const links = document.querySelectorAll(
    "a[href*='#']:not([href='#']):not([href*='#int-']):not([href='#0']):not([target='_blank'])"
  );

  for (const link of links) {
    link.addEventListener("click", clickHandler);
  }

  function clickHandler(e) {
    if (this.pathname !== window.location.pathname || this.hostname !== window.location.hostname) {
      return;
    }

    const target = document.querySelector(this.hash);
    if (!target) {
      return;
    }

    e.preventDefault();
    const offsetTop = target.offsetTop;

    if (stickyAnchors) {
      scroll({
        top: offsetTop - stickyAnchors + 2,
        behavior: "smooth",
      });
    } else {
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  }
}

function anchorHighlight() {
  const anchors = $j(".flx-anchor");
  const anchorsNextEl = $j(anchors).next();
  const anchorDestinations = gsap.utils.toArray(anchorsNextEl);

  if (typeof anchorDestinations != "undefined" && anchorDestinations != null) {
    const stickyNavsHeight = $j(".flx-anchor-links__wrap").outerHeight();

    anchorDestinations.forEach((anchorDestination) => {
      const prevEl = $j(anchorDestination).prev();
      const idOfElement = $j(prevEl).attr("id");
      const anchorStickyLink = $j('a[href^="#' + idOfElement + '"]');
      
      // console.log(anchorDestination);
      const endTrigger = $j(anchorDestination).next('.flx-anchor');
      // console.log('this is the endTrigger', endTrigger);

      console.log('this is the endTrigger', endTrigger);

      ScrollTrigger.create({
        trigger: anchorDestination,
        start: () => "top " + stickyNavsHeight,
        // endTrigger: endTrigger,
        end: () => "bottom " + stickyNavsHeight,

        onEnter: () => $j(anchorStickyLink).addClass("active"),
        onLeave: () => $j(anchorStickyLink).removeClass("active"),
        onEnterBack: () => $j(anchorStickyLink).addClass("active"),
        onLeaveBack: () => $j(anchorStickyLink).removeClass("active"),

        markers: false
      });

    });
  }
}

// GSAP animations

// Animate on scroll (GSAP)

function gsapAnimateScroll() {
  const faders = gsap.utils.toArray("[data-vas='fade']");

  if (typeof faders != "undefined" && faders != null) {
    faders.forEach((fader) => {
      gsap.set(fader, {
        autoAlpha: 0,
      });

      // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
      let faderDelay;

      if (fader.hasAttribute("data-vas-delay")) {
        faderDelay = fader.getAttribute("data-vas-delay");
      } else {
        faderDelay = 0;
      }

      ScrollTrigger.create({
        trigger: fader,
        start: "top bottom",
        markers: false,
        onEnter: () =>
          gsap.to(fader, {
            autoAlpha: 1,
            duration: 1,
            delay: faderDelay,
            overwrite: true,
          }),
        onEnterBack: () =>
          gsap.to(fader, {
            autoAlpha: 1,
            duration: 1,
            overwrite: true,
          }),
        onLeaveBack: () =>
          gsap.to(fader, {
            autoAlpha: 0,
            overwrite: true,
          }),
      });
    });
  }

  // Slide up
  const fadersSU = gsap.utils.toArray("[data-vas='fade-up']");

  if (typeof fadersSU != "undefined" && fadersSU != null) {
    fadersSU.forEach((faderSU) => {
      gsap.set(faderSU, {
        y: 50,
        autoAlpha: 0,
      });

      // NB data-delay value must be in seconds, so it would be 0.2 for the equivalent "200" AOS value which is in milliseconds
      let faderDelay;

      if (faderSU.hasAttribute("data-vas-delay")) {
        faderDelay = faderSU.getAttribute("data-vas-delay");
      } else {
        faderDelay = 0.1;
      }

      ScrollTrigger.create({
        trigger: faderSU,
        start: "top bottom",
        markers: false,

        onEnter: () =>
          gsap.to(faderSU, {
            y: 0,
            autoAlpha: 1,
            duration: 0.5,
            delay: faderDelay,
            overwrite: true,
            ease: "power3",
          }),

        onLeaveBack: () =>
          gsap.to(faderSU, {
            y: 50,
            autoAlpha: 0,
            duration: 0.5,
            overwrite: true,
          }),
      });
    });
  }

  // Letter-by-letter reveal — used for the footer's big headline, copying
  // gravity.co's own footer text reveal: each letter wipes in left-to-right
  // via a shrinking clip-path inset rather than fading up from below, so it
  // reads as the letter being drawn across rather than appearing. Gravity's
  // own version runs quite fast; this stays slightly slower per letter but
  // a tighter stagger than the first pass so the overall sweep across
  // "Love martech" is quicker start-to-finish.
  const lettersEls = gsap.utils.toArray("[data-vas='letters']");

  if (typeof lettersEls != "undefined" && lettersEls != null) {
    lettersEls.forEach((lettersEl) => {
      const letters = lettersEl.querySelectorAll(".footer-headline__letter");

      if (!letters.length) {
        return;
      }

      gsap.set(letters, {
        clipPath: "inset(0 100% 0 0)",
      });

      ScrollTrigger.create({
        trigger: lettersEl,
        start: "top bottom",
        markers: false,

        onEnter: () =>
          gsap.to(letters, {
            clipPath: "inset(0 0% 0 0)",
            duration: 0.6,
            stagger: 0.025,
            ease: "power2.out",
            overwrite: true,
          }),

        onLeaveBack: () =>
          gsap.set(letters, {
            clipPath: "inset(0 100% 0 0)",
          }),
      });
    });
  }
}

function heroParallax() {
  const heroImgs = document.querySelectorAll(".hero-parallax");

  if (typeof heroImgs != "undefined" && heroImgs != null) {
    heroImgs.forEach((heroImg) => {
      gsap.to(heroImg, {
        y: 300,
        scale: 1.04,
        scrollTrigger: {
          markers: false,
          trigger: heroImg,
          start: "2%",
          scrub: true,
        },
      });
    });
  }
}

function headerParallax() {
  const heroImgs = document.querySelectorAll(".header-parallax");

  if (typeof heroImgs != "undefined" && heroImgs != null) {
    heroImgs.forEach((heroImg) => {
      gsap.to(heroImg, {
        y: 200,
        scale: 1.04,
        scrollTrigger: {
          markers: false,
          trigger: heroImg,
          start: "2%",
          scrub: true,
        },
      });
    });
  }
}

function imageParallax() {
  // const images = document.querySelectAll(".image-parallax");
  let images = gsap.utils.toArray(".image-parallax");

  images.forEach((image) => {
    if (typeof image != "undefined" && image != null) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: image,
          scrub: true,
          pin: false,
          start: "top bottom",
          end: "bottom top",
        },
      });

      tl.fromTo(
        image,
        {
          yPercent: -20,
          scale: 1.2,
          ease: "none",
        },
        {
          yPercent: 20,
          ease: "none",
        }
      );
    }
  });
}

// Scrolling text/media (flx-scrolling-text-media)
// Both lines run the identical leftward scrub tween below - the bottom line's
// rightward appearance (and its mirrored dot placement) comes entirely from the
// CSS horizontal flip on .flx-scrolling-text-media__line--bottom (see SCSS).
function flxScrollingTextMedia() {
  const blocks = document.querySelectorAll(".flx-scrolling-text-media");

  if (!blocks.length) {
    return;
  }

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  // Reduced-motion users get the static, unshifted markup order with no scrub tween at all.
  if (prefersReducedMotion) {
    return;
  }

  // Below 768px the phrase-gap dots become visible (see CSS), and the top/bottom
  // lines otherwise scrub in perfect lockstep, keeping their dots in the same
  // vertical column for the whole scroll. Phase-shift the bottom line by its own
  // scrub distance on mobile so the two rows' dots stagger further out of column.
  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  blocks.forEach((block) => {
    const lines = block.querySelectorAll(".flx-scrolling-text-media__line");

    lines.forEach((line, lineIndex) => {
      const track = line.querySelector(".flx-scrolling-text-media__track");

      if (!track) {
        return;
      }

      // Scroll-scrub speed: 1 = the track fully clears its overflow across the block's
      // scroll range, 0.5 = half that distance (i.e. half speed).
      const SCRUB_SPEED = 0.05;

      // Re-measured on every ScrollTrigger refresh so edits to the text or a resize
      // can never leave the track short of the container width.
      const getDistance = () =>
        Math.max(track.scrollWidth - line.clientWidth, 0) * SCRUB_SPEED;

      const getOffset = () =>
        isMobile && lineIndex % 2 === 1 ? getDistance() : 0;

      gsap.fromTo(
        track,
        { x: () => -getOffset() },
        {
          x: () => -getDistance() - getOffset(),
          ease: "none",
          scrollTrigger: {
            trigger: block,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            invalidateOnRefresh: true,
          },
        }
      );
    });
  });
}

// Image carousel (flx-image-carousel)
// A centred "hero" slide with its neighbours peeking in half-visible at each
// edge, gently auto-rotating to the next slide on an even interval — a slow,
// discrete rotation rather than a continuous marquee drift. Swiper's own loop
// mode handles the seamless wrap (it clones slides internally), so there's no
// manual DOM duplication here.
function flxImageCarousel() {
  const blocks = document.querySelectorAll(".flx-image-carousel__swiper");

  if (!blocks.length) {
    return;
  }

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  // slidesPerView:"auto" + a CSS width on the slide (see the SCSS) is
  // Swiper's own recommended pattern for a centred slide with peeking
  // neighbours — a numeric, even slidesPerView doesn't pair reliably with
  // centeredSlides+loop (it was producing a wrong initial slide and a
  // stalled autoplay). observer/observeParents re-measure slide widths
  // after the full-bleed layout settles, which is what removes the jump.
  //
  // loop is only safe to request when there are enough real slides — Swiper
  // needs at least slidesPerViewDynamic() + its own computed loopedSlides
  // (however many slides fit on screen, plus a duplication buffer) or it
  // logs "not enough slides for loop mode" and the loop breaks (lands on
  // the last real slide instead of a centred one, autoplay stalling). That
  // threshold depends on the measured slide width, so it's only knowable
  // after Swiper has actually laid the slides out — see the loop check
  // below rather than a slide-count guess made up front.
  const buildConfig = (loopEnabled) => ({
    slidesPerView: "auto",
    centeredSlides: true,
    initialSlide: 0,
    observer: true,
    observeParents: true,
    loop: loopEnabled,
    // Falls back to rewind (same "jump back to the start" wrap, driven by
    // real slides only) when there aren't enough slides for Swiper's loop
    // clones — mirrors swiperTeam() above.
    rewind: !loopEnabled,
    speed: 900,
    spaceBetween: 16,
    grabCursor: true,
    // Reduced-motion users still get the centred/peeking layout and can
    // browse it by drag or swipe — it simply never advances on its own.
    autoplay: prefersReducedMotion
      ? false
      : {
          delay: 4000,
          disableOnInteraction: false,
        },
    breakpoints: {
      768: {
        spaceBetween: 24,
      },
      1200: {
        spaceBetween: 74,
      },
    },
  });

  blocks.forEach((el) => {
    const slideCount = el.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(el, buildConfig(true));

    const requiredForLoop = swiper.slidesPerViewDynamic() + swiper.loopedSlides;
    if (slideCount < requiredForLoop) {
      swiper.destroy(true, true);
      new Swiper(el, buildConfig(false));
    }
  });
}

// Insights & News: fade in a card's image/video background on hover, and
// only start playing the video once it's actually visible (rather than
// autoplaying every card's video on page load).
function flxInsightsNewsHover() {
  const cards = document.querySelectorAll(".flx-insights-news__card");

  cards.forEach((card) => {
    const video = card.querySelector(".flx-insights-news__bg video");

    if (!video) {
      return;
    }

    const play = () => video.play();
    const stop = () => {
      video.pause();
      video.currentTime = 0;
    };

    card.addEventListener("mouseenter", play);
    card.addEventListener("mouseleave", stop);
    card.addEventListener("focus", play);
    card.addEventListener("blur", stop);
  });
}

// Insight single sidebar — on mobile, swap the fixed Email/LinkedIn links
// for a single native share button so the OS share sheet surfaces
// whatever apps are actually installed, rather than a fixed pair of
// icons. Falls back to the Email/LinkedIn links on desktop, and on any
// mobile browser without Web Share API support.
function flxInsightShare() {
  const nativeBtn = document.querySelector("[data-native-share]");

  if (!nativeBtn) {
    return;
  }

  const fallbackLinks = document.querySelectorAll(
    ".insight-single__sidebar-action--fallback"
  );
  const mobileQuery = window.matchMedia("(max-width: 991px)");

  const updateShareUI = () => {
    const useNative = Boolean(navigator.share) && mobileQuery.matches;

    nativeBtn.hidden = !useNative;
    fallbackLinks.forEach((link) => {
      link.hidden = useNative;
    });
  };

  updateShareUI();
  mobileQuery.addEventListener("change", updateShareUI);

  nativeBtn.addEventListener("click", () => {
    navigator
      .share({
        title: nativeBtn.dataset.shareTitle,
        url: nativeBtn.dataset.shareUrl,
      })
      .catch(() => {});
  });
}

function alertBar() {
  if ($j("#alert-bar").length > 0) {
    const alertBarClose = document.querySelector(".alert-bar__close");
    const alertBar = document.querySelector("#alert-bar");
    const siteHeader = document.querySelector("#site-header");
    const headerHero = document.querySelector(".header-hero");
    // const headerImg = document.querySelector(".header-image");
    // const headerStd = document.querySelector(".header-standard");
    // const anchorLinks = document.querySelector(".flx-anchor-links__wrap");

    const megaMenuEls = document.querySelectorAll(
      ".mega-menu, #mega-menu-backdrop"
    );
    const alertBarHeight = alertBar.offsetHeight;

    document.body.style.marginTop = alertBarHeight + "px";
    // siteHeader.style.marginTop = alertBarHeight + "px";

    if (headerHero) {
      headerHero.style.height = "calc(100vh -  " + alertBarHeight + "px)";
    }

    // if (headerStd) {
    //   headerStd.classList.add('alert-bar');
    // }

    if (megaMenuEls) {
      megaMenuEls.forEach((el) => {
        el.style.top = "calc(var(--header-height) + " + alertBarHeight + "px)";
      });
    }

    alertBarClose.onclick = () => {
      alertBar.style.display = "none";
      document.body.style.marginTop = 0 + "px";
      siteHeader.style.marginTop = 0 + "px";

      if (headerHero) {
        headerHero.style.height = 100 + "%";
      }

      if (megaMenuEls) {
        megaMenuEls.forEach((el) => {
          el.style.top = "var(--header-height)";
        });
      }

      // Cookie is set for 10 days
      document.cookie = "alertbar=set; max-age=864000; path=/";

      gsapAnimateScroll();
    };
  }
}

// Video
function playVideo() {
  if ($j(".video-player").length > 0) {
    let videos = gsap.utils.toArray(".video-player");

    videos.forEach((video) => {
      let player = video.querySelector("video");

      const restartVideo = (el) => {
        el.pause();
        el.currentTime = 0;
      };

      ScrollTrigger.create({
        trigger: player,
        start: "top bottom",
        end: "bottom top",
        markers: false,

        onEnter: () => player.play(),
        onEnterBack: () => player.play(),
        onLeave: () => restartVideo(player),
        onLeaveBack: () => restartVideo(player),
      });
    });
  }
}

// Swipers

function swiperHero() {
  new Swiper(".hero-swiper", {
    effect: "fade",
    speed: 800,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".hero-swiper-pagination",
      clickable: true,
    },
  });
}

function swiperMarquee() {
  new Swiper(".swiper-marquee", {
    slidesPerView: "auto",
    spaceBetween: "2%",
    loop: true,
    speed: 10000,
    allowTouchMove: false,
    loopAdditionalSlides: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  });
}

function swiperQuicklinks() {
  new Swiper(".quicklinks-swiper", {
    spaceBetween: 24,
    speed: 800,
    slidesPerView: 1,
    loop: true,
    loopAdditionalSlides: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
    },
  });
}

// Shared by swiperServices() and swiperListCarousel() (both slidesPerView:
// "auto" + rewind). Swiper's own snap grid for "auto" mode ends with one
// entry per slide, PLUS a final entry clamped to the true scroll boundary
// so the last slide's edge can reach the end of the track — that boundary
// entry sometimes lands within a pixel or two of the previous slide's own
// entry, so the click landing on it doesn't visibly move anything, and
// rewind then needs one more, seemingly dead, click to fire. Collapsing
// near-duplicate consecutive entries removes that dead click while still
// keeping the boundary entry whenever it's a real, distinct position —
// i.e. the carousel still ends flush against the track's edge.
function dedupeSwiperSnapGrid(swiper) {
  // The narrowest real card + gap step either carousel ever uses is ~327px
  // (List's mobile breakpoint), so anything under that is unambiguously a
  // boundary-clamp artifact rather than a genuine next slide — this needs
  // to be well clear of both, since the artifact's size varies with
  // viewport/content width (seen as small as ~4px and as large as ~20px).
  const threshold = 60;
  const grid = swiper.snapGrid;
  const deduped = [grid[0]];

  for (let i = 1; i < grid.length; i++) {
    if (Math.abs(grid[i] - deduped[deduped.length - 1]) > threshold) {
      deduped.push(grid[i]);
    }
  }

  swiper.snapGrid = deduped;
}

function swiperTeam() {
  new Swiper(".flx-team-carousel__slider", {
    spaceBetween: 24,
    speed: 800,
    slidesPerView: 1,
    loop: false,
    rewind: true,
    loopAdditionalSlides: true,
    // initialSlide: 2,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-team-button-next",
      prevEl: ".swiper-team-button-prev",
    },
  });
}

function swiperServices() {
  // Scoped to .carousel: a "grid" layout flx-services block can appear on
  // the same page and shares the .flx-services__slider class, but it has no
  // .swiper-wrapper/.swiper-slide structure inside it — an unscoped selector
  // here would grab that one first (DOM order) and crash Swiper's mount.
  new Swiper(".flx-services.carousel .flx-services__slider", {
    slidesPerView: "auto",
    spaceBetween: 32,
    speed: 800,
    watchOverflow: true,
    rewind: true,
    navigation: {
      nextEl: ".swiper-services-button-next",
      prevEl: ".swiper-services-button-prev",
    },
    // "update" (in addition to "init"/"resize") also catches Swiper's own
    // updateOnImagesReady recalculation — cards whose images are still
    // loading at init time change size once they finish, giving a
    // *second*, later snap grid that init-time deduping alone would miss
    // entirely. update() runs at the end of every resize too, so this
    // covers that path as well; re-running the (idempotent) dedupe is
    // harmless.
    on: {
      init: dedupeSwiperSnapGrid,
      resize: dedupeSwiperSnapGrid,
      update: dedupeSwiperSnapGrid,
    },
  });
}

function swiperCaseStudies() {
  const el = document.querySelector(".flx-case-studies__slider");

  if (!el) {
    return;
  }

  // loop (rather than rewind, which it's mutually exclusive with) is what
  // puts a previous card in view to the left of the centred starting slide
  // — Swiper clones slides to pad both ends, so there's always a "previous"
  // one to peek even on the very first card.
  //
  // Swiper 11+ doesn't clone slides for loop mode — it physically moves real
  // slides from one end to the other, and needs roughly slidesPerView plus
  // half as many again (it ignores any loopedSlides we pass). With few case
  // studies (e.g. 3 on a filtered page) the slide being moved is on screen,
  // so the carousel jumps and the wrap breaks. Duplicating the whole set
  // (keeping order) until there are enough slides avoids that; 8 covers
  // the widest viewports at every breakpoint's card width.
  const wrapper = el.querySelector(".swiper-wrapper");
  const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
  const minLoopSlides = 8;

  if (slides.length > 1) {
    while (wrapper.children.length < minLoopSlides) {
      slides.forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));
    }
  }

  new Swiper(el, {
    slidesPerView: "auto",
    spaceBetween: 32,
    speed: 800,
    centeredSlides: true,
    watchOverflow: true,
    // A single case study has nothing to loop through.
    loop: slides.length > 1,
    initialSlide: 0,
    navigation: {
      nextEl: ".swiper-case-studies-button-next",
      prevEl: ".swiper-case-studies-button-prev",
    },
  });
}

function swiperListCarousel() {
  new Swiper(".flx-list-carousel__slider", {
    slidesPerView: "auto",
    spaceBetween: 31,
    speed: 800,
    watchOverflow: true,
    rewind: true,
    navigation: {
      nextEl: ".swiper-list-carousel-button-next",
      prevEl: ".swiper-list-carousel-button-prev",
    },
    // See the matching "on" block in swiperServices() above.
    on: {
      init: dedupeSwiperSnapGrid,
      resize: dedupeSwiperSnapGrid,
      update: dedupeSwiperSnapGrid,
    },
  });
}

// Partner logos (flx-partner-logos)
// The marquee itself is pure CSS (see the animation on .flx-partner-logos__logos
// in the SCSS) — this only tunes its speed. A single fixed animation-duration
// looks like different speeds on different instances because each one
// travels a different pixel distance per cycle (the compact layout's gap is
// nearly twice the default layout's, and the logo count varies block to
// block), so this measures each instance's own rendered width and sets its
// duration to match a shared px/second constant instead — every Partner
// Logos block then drifts at the same visual speed regardless of its gap or
// logo count. Only reads layout (scrollWidth/getComputedStyle), nothing that
// can throw the way Swiper's old loop-mode validation could, so one
// instance's edge case can't take down another's; if this doesn't run at
// all (JS disabled), the SCSS's own fixed-duration animation still plays.
function flxPartnerLogosMarqueeSpeed() {
  const tracks = document.querySelectorAll(".flx-partner-logos__logos");

  if (!tracks.length) {
    return;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  // Tuned to match the default layout's original fixed 28s duration at a
  // typical logo count/width.
  const PX_PER_SECOND = 40;

  tracks.forEach((track) => {
    const repeats =
      Number(getComputedStyle(track).getPropertyValue("--flx-pl-repeats")) ||
      4;
    const oneSetWidth = track.scrollWidth / repeats;

    if (!oneSetWidth) {
      return;
    }

    track.style.animationDuration = `${oneSetWidth / PX_PER_SECOND}s`;
  });
}

// Scales the footer's big headline ("Love martech" by default, but it's a
// CMS field so length varies) so its rendered width always exactly fills
// the footer container, then re-fills on resize — the fluid-type effect
// seen on gravity.co's footer wordmark. That one's a fixed SVG logo, so
// width:100% is enough on its own; ours is variable-length text, which
// has no CSS-only way to size to an exact rendered width, hence measuring
// it here. Reset to a large reference size first so scrollWidth reflects
// the text's natural (unscaled) width at a known ratio, then scale that
// ratio to the available width — measuring from the current (already
// scaled) font-size instead would compound rounding error on every resize.
function footerHeadlineFit() {
  const headline = document.querySelector(".footer-headline");

  if (!headline) {
    return;
  }

  const REFERENCE_FONT_SIZE = 1000; // px; arbitrary but large enough for an accurate ratio

  function fit() {
    headline.style.fontSize = `${REFERENCE_FONT_SIZE}px`;

    const naturalWidth = headline.scrollWidth;
    // headline's own rendered width, not its parent's — .footer-wrap's
    // clientWidth includes its horizontal padding, which .footer-headline
    // (an ordinary block box) doesn't extend into, so sizing against the
    // parent fit the text too wide by that padding and let it overflow.
    const availableWidth = headline.getBoundingClientRect().width;

    if (!naturalWidth || !availableWidth) {
      return;
    }

    headline.style.fontSize = `${
      REFERENCE_FONT_SIZE * (availableWidth / naturalWidth)
    }px`;
  }

  fit();

  // Re-measure once webfonts land — glyph metrics (and so scrollWidth)
  // shift when the fallback font swaps for the real one.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fit);
  }

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fit, 150);
  });
}

// Shared Lottie icon helpers -------------------------------------------
// Used by both the flx-services cards below and the mega menu submenu
// icons (see activateMegaMenuLottieIcons() in the nav section above):
// creates one lottie-web instance per icon element, guarded by
// [data-lottie-ready] so a second init pass never creates duplicate
// instances, and applies the same reduced-motion "settle on the final
// frame" fallback in both places.
const LOTTIE_PLAYBACK_SPEED = 2;

function lottiePrefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function createLottieIcon(iconEl, reduceMotion) {
  const src = iconEl.dataset.lottieSrc;

  if (!src || iconEl.hasAttribute("data-lottie-ready")) {
    return null;
  }

  iconEl.setAttribute("data-lottie-ready", "");

  const anim = lottie.loadAnimation({
    container: iconEl,
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: src,
  });

  anim.setSpeed(LOTTIE_PLAYBACK_SPEED);

  if (reduceMotion) {
    anim.addEventListener("DOMLoaded", () => {
      anim.goToAndStop(anim.totalFrames - 1, true);
    });
  }

  return anim;
}

// Services (flx-services) and Small Services Cards
// (flx-small-services-cards): animated Lottie icons. Each .js-lottie-icon
// gets its own lottie instance, played once (no loop) the first time its
// card enters the viewport, and replayed from frame 0 on every card
// mouseenter/focusin after that. A single shared IntersectionObserver covers
// every icon on the page (cheaper than one observer per card) and
// un-observes each icon the moment it has played once, so scrolling a card
// in and out of view again never replays it. The [data-lottie-ready] guard
// (set inside createLottieIcon()) stops a second call to this function from
// loading duplicate animations or attaching duplicate hover/focus listeners
// onto the same elements. Scoped to these two blocks' own icon classes
// specifically (rather than every .js-lottie-icon on the page) so it never
// touches the mega menu's own Lottie icons, which start hidden and are
// activated separately.
function flxServicesLottieIcons() {
  const icons = document.querySelectorAll(
    ".flx-services__icon.js-lottie-icon:not([data-lottie-ready]), .flx-small-services-cards__icon.js-lottie-icon:not([data-lottie-ready])"
  );

  if (!icons.length) {
    return;
  }

  const reduceMotion = lottiePrefersReducedMotion();
  const animations = new Map();

  // Reduced motion: no autoplay, no hover/focus replay — just settle on the
  // animation's final frame as a static state once it has loaded.
  // Threshold is deliberately low so a card's icon starts playing as soon as
  // a small sliver of it scrolls into view, rather than waiting for the
  // card to be mostly on screen.
  const viewportObserver = reduceMotion
    ? null
    : new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            observer.unobserve(entry.target);

            const anim = animations.get(entry.target);

            if (anim) {
              anim.goToAndPlay(0, true);
            }
          });
        },
        { threshold: 0.1 }
      );

  icons.forEach((iconEl) => {
    const anim = createLottieIcon(iconEl, reduceMotion);

    if (!anim || reduceMotion) {
      return;
    }

    animations.set(iconEl, anim);
    viewportObserver.observe(iconEl);

    const card = iconEl.closest(
      ".flx-services__card, .flx-small-services-cards__card"
    );

    if (!card) {
      return;
    }

    const replay = () => anim.goToAndPlay(0, true);

    card.addEventListener("mouseenter", replay);
    card.addEventListener("focusin", replay);
  });
}

// Page header (Standard layout): recolored Lottie icon on the dark theme.
// The icon library's shapes are all baked in navy (#2C2E3E) — correct for
// the Services cards' light pink background, but invisible (navy-on-navy)
// against the header's own dark background. header-standard.php marks an
// icon needing this with [data-lottie-recolor="<hex>"], in which case we
// fetch the raw animation JSON ourselves (rather than handing lottie-web
// the path directly) and swap that one baked-in navy fill for the target
// color before rendering, leaving the separate black mask shapes — used
// for internal compositing, not drawn on screen — untouched.
const LOTTIE_SOURCE_FILL = [0.172549, 0.180392, 0.243137]; // #2C2E3E, Lottie's normalized 0-1 color format

function hexToLottieColor(hex) {
  const int = parseInt(hex, 16);

  return [((int >> 16) & 255) / 255, ((int >> 8) & 255) / 255, (int & 255) / 255];
}

function isCloseColor(a, b) {
  return a.every((value, i) => Math.abs(value - b[i]) < 0.01);
}

function recolorLottieFills(node, targetColor) {
  if (Array.isArray(node)) {
    node.forEach((item) => recolorLottieFills(item, targetColor));
    return;
  }

  if (!node || typeof node !== "object") {
    return;
  }

  if (
    node.c &&
    Array.isArray(node.c.k) &&
    node.c.k.length === 3 &&
    isCloseColor(node.c.k, LOTTIE_SOURCE_FILL)
  ) {
    node.c.k = targetColor;
  }

  Object.values(node).forEach((value) => recolorLottieFills(value, targetColor));
}

function createRecoloredLottieIcon(iconEl, reduceMotion, targetHex) {
  const src = iconEl.dataset.lottieSrc;

  if (!src || iconEl.hasAttribute("data-lottie-ready")) {
    return;
  }

  iconEl.setAttribute("data-lottie-ready", "");

  fetch(src)
    .then((response) => response.json())
    .then((data) => {
      recolorLottieFills(data, hexToLottieColor(targetHex));

      // Unlike the path-based loader below, animationData is already in
      // memory, so lottie-web builds the SVG synchronously inside
      // loadAnimation() itself — "DOMLoaded" has already fired by the time
      // we'd attach a listener for it here, so play/stop directly instead.
      const anim = lottie.loadAnimation({
        container: iconEl,
        renderer: "svg",
        loop: false,
        autoplay: !reduceMotion,
        animationData: data,
      });

      anim.setSpeed(LOTTIE_PLAYBACK_SPEED);

      if (reduceMotion) {
        anim.goToAndStop(anim.totalFrames - 1, true);
      }
    })
    .catch(() => {
      // Fall back to lottie's own loader (original navy color) rather than
      // leaving the icon blank if the fetch/recolor fails for any reason.
      iconEl.removeAttribute("data-lottie-ready");

      const anim = createLottieIcon(iconEl, reduceMotion);

      if (anim && !reduceMotion) {
        anim.addEventListener("DOMLoaded", () => anim.goToAndPlay(0, true));
      }
    });
}

// Page header (Standard layout): animated Lottie icon.
// Unlike the services cards, this icon sits in the header itself, so it's
// on screen as soon as the page loads — no IntersectionObserver or
// hover/focus replay needed, it just plays once on load. Falls back to
// settling on the final frame under reduced motion, same as everywhere
// else createLottieIcon() is used.
//
// Start is deliberately delayed to match the #page-preloader overlay (see
// the Preloader section below and site/_site.scss): it holds for
// PRELOADER_HOLD_MS then fades out over a PRELOADER_FADE_MS CSS opacity
// transition, so without this delay the icon would run — and finish —
// hidden behind it, and be static by the time the page reveals.
// PRELOADER_FADE_MS must match the transition on #page-preloader.
const PRELOADER_HOLD_MS = 400;
const PRELOADER_FADE_MS = 300;
const HEADER_LOTTIE_START_DELAY = PRELOADER_HOLD_MS + PRELOADER_FADE_MS;

function headerStandardLottieIcon() {
  setTimeout(() => {
    const iconEl = document.querySelector(
      ".header-standard__lottie.js-lottie-icon:not([data-lottie-ready])"
    );

    if (!iconEl) {
      return;
    }

    const reduceMotion = lottiePrefersReducedMotion();
    const recolorHex = iconEl.dataset.lottieRecolor;

    if (recolorHex) {
      createRecoloredLottieIcon(iconEl, reduceMotion, recolorHex);
      return;
    }

    const anim = createLottieIcon(iconEl, reduceMotion);

    if (!anim || reduceMotion) {
      return;
    }

    anim.addEventListener("DOMLoaded", () => {
      anim.goToAndPlay(0, true);
    });
  }, HEADER_LOTTIE_START_DELAY);
}

// Testimonials (flx-testimonials)
// A single-slide-at-a-time quote carousel. Instantiated per element (rather
// than by a shared class selector) so multiple Testimonial blocks on one
// page each get their own Swiper instance and their own scoped nav buttons,
// instead of every instance fighting over the first slider/button found.
function swiperTestimonials() {
  const sliders = document.querySelectorAll(".flx-testimonials__slider");

  sliders.forEach((el) => {
    const wrap = el.closest(".flx-testimonials__wrap");

    if (!wrap) {
      return;
    }

    new Swiper(el, {
      slidesPerView: 1,
      speed: 600,
      loop: false,
      rewind: true,
      watchOverflow: true,
      navigation: {
        nextEl: wrap.querySelector(".swiper-testimonials-button-next"),
        prevEl: wrap.querySelector(".swiper-testimonials-button-prev"),
      },
    });
  });
}

function swiperRel() {
  new Swiper(".related-blog__swiper", {
    spaceBetween: 16,
    speed: 800,
    slidesPerView: 1,
    loop: false,
    rewind: true,
    loopAdditionalSlides: true,
    // initialSlide: 2,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-related-button-next",
      prevEl: ".swiper-related-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 32,
        // spaceBetween: 40,
      },
      // 1024: {
      //   slidesPerView: 5,
      //   spaceBetween: 50,
      // },
    },
  });
}

function swiperBlog() {
  new Swiper(".blog-swiper", {
    spaceBetween: 16,
    speed: 800,
    loop: false,
    rewind: true,
    loopAdditionalSlides: true,
    // initialSlide: 1,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-blog-button-next",
      prevEl: ".swiper-blog-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1200: {
        slidesPerView: 3,
        // spaceBetween: 40,
      },
      // 1024: {
      //   slidesPerView: 5,
      //   spaceBetween: 50,
      // },
    },
  });
}

// Videos

// Header hero: video
function headerHeroVideo() {
  if ($j(".header-hero").length > 0) {
    let videos = gsap.utils.toArray(".header-hero__video");

    videos.forEach((video) => {
      let player = video.querySelector("video");

      const restartVideo = (el) => {
        el.pause();
        el.currentTime = 0;
      };

      ScrollTrigger.create({
        trigger: player,
        start: "top bottom",
        end: "bottom top",
        markers: false,

        onEnter: () => player.play(),
        onEnterBack: () => player.play(),
        onLeave: () => restartVideo(player),
        onLeaveBack: () => restartVideo(player),
      });
    });
  }
}

// Sticky elements
function flxStickyEl() {
  if ($j(".sticky-element").length > 0) {
    new Sticky(".sticky");

    const navbar = document.querySelector("#site-header");

    ScrollTrigger.create({
      trigger: '.sticky-element',
      start: "top top",
      end: "none top",
      markers: false,

      // onEnter: () => player.play(),
      // onEnterBack: () => player.play(),
      // onLeave: () => restartVideo(player),
      // onLeaveBack: () => restartVideo(player),

      onEnter: () => $j(navbar).addClass("sticky-active"),
      onLeaveBack: () => $j(navbar).removeClass("sticky-active")

      // onEnterBack: () => $j(anchorStickyLink).addClass("active"),
      // onLeaveBack: () => $j(anchorStickyLink).removeClass("active"),

    });
  }
}

//// Flexible content functions ////

// Form (Embed) — Marketo forms2 confirmation.
// A Marketo form with no "Thank You" follow-up page configured just
// redirects back to the same URL on submit, which reads as the page
// silently refreshing with no confirmation. This hooks Marketo's own
// Forms2 API (whenReady/onSuccess — see
// https://developers.marketo.com/javascript-api/forms/) to intercept that:
// returning false from onSuccess cancels Marketo's own follow-up action, and
// in its place we hide the form and reveal the block's
// .flx-form-embed__confirmation message (see partials/flexible-form-embed.php)
// sitting alongside it. Degrades to Marketo's default behaviour untouched if
// MktoForms2 isn't present (e.g. the pasted embed code hasn't loaded yet).
function flxFormEmbedConfirmation() {
  if (typeof MktoForms2 === "undefined") {
    return;
  }

  MktoForms2.whenReady(function (form) {
    const formEl = form.getFormElem()[0];
    const container = formEl.closest(".flx-form-embed__form");

    if (!container) {
      return;
    }

    const confirmation = container.querySelector(
      ".flx-form-embed__confirmation"
    );

    form.onSuccess(function () {
      // The [hidden] attribute alone can't hide the form: .mktoForm's own
      // `display: grid !important` (see _flexible-form-embed.scss) beats the
      // UA stylesheet's un-important `[hidden]{display:none}` rule, so this
      // relies on a more specific !important override instead (see the
      // .flx-form-embed__form--submitted .mktoForm rule in that file).
      container.classList.add("flx-form-embed__form--submitted");

      if (confirmation) {
        confirmation.hidden = false;
        confirmation.focus();
      }

      // Editor-configured GA4 event tracking (Category/Action/Label/Value
      // fields on the block — see partials/flexible-form-embed.php). Pushed
      // to GTM's data layer rather than calling gtag() directly, since the
      // site loads Google Tag Manager (see inc/wp-custom.php); a GA4 Event
      // tag in GTM reads these as its trigger/variables.
      if (container.dataset.gaCategory) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "form_submission",
          eventCategory: container.dataset.gaCategory,
          eventAction: container.dataset.gaAction || "",
          eventLabel: container.dataset.gaLabel || "",
          eventValue: container.dataset.gaValue || "",
        });
      }

      // Cancel Marketo's own default follow-up (e.g. redirecting back to
      // this same page, which is what reads as an unexplained refresh).
      return false;
    });
  });
}

// Download — Marketo forms2 gate.
// Mirrors flxFormEmbedConfirmation() above, for a gated download card (see
// partials/flexible-download.php): onSuccess hides the form and reveals a
// static confirmation message in its place, still inline in the card — the
// actual download link is emailed by Marketo's own autoresponder, not shown
// on the page. Cancelling Marketo's own follow-up (return false) also stops
// it redirecting back to this same page.
function flxDownloadGate() {
  if (typeof MktoForms2 === "undefined") {
    return;
  }

  MktoForms2.whenReady(function (form) {
    const formEl = form.getFormElem()[0];
    const gate = formEl.closest(".flx-download__gate");

    if (!gate) {
      return;
    }

    const confirmation = gate.querySelector(".flx-download__confirmation");

    form.onSuccess(function () {
      gate.classList.add("flx-download__gate--submitted");

      if (confirmation) {
        confirmation.hidden = false;
        confirmation.focus();
      }

      return false;
    });
  });
}

// Form (Embed) — floating-label / autofill fix.
// .mktoLabel floats over its field like a placeholder, fading out on
// :focus-within (see _flexible-form-embed.scss) — but that leaves it sitting
// on top of the field's value once entered, most visibly with browser
// autofill, which fills fields without ever focusing them. Marketo doesn't
// put a native `placeholder` attribute on its own fields, so the CSS
// :placeholder-shown state this needs isn't available by default; setting
// one here (a single space — invisible, since .mktoLabel already covers the
// field) makes the browser track "has a value" accurately, autofill
// included, and the CSS hides the label whenever that's true. Deliberately
// skips checkbox/radio/select — :placeholder-shown doesn't apply to them,
// and the checkbox/radio label is Marketo's separate, non-floating consent
// text (see the .mktoFormRow:has(.mktoCheckboxList) rules), not this
// overlay.
function flxFormEmbedFloatingLabels() {
  if (typeof MktoForms2 === "undefined") {
    return;
  }

  MktoForms2.whenReady(function (form) {
    const formEl = form.getFormElem()[0];

    formEl
      .querySelectorAll(
        'input.mktoField:not([type="checkbox"]):not([type="radio"]), textarea.mktoField'
      )
      .forEach((field) => {
        if (!field.hasAttribute("placeholder")) {
          field.setAttribute("placeholder", " ");
        }
      });
  });
}

// Vanilla Modal
function vanillaModal() {
  const modals = document.querySelectorAll("[data-modal]");
  const body = document.documentElement;

  modals.forEach(function (trigger) {
    const modal = document.getElementById(trigger.dataset.modal);
    const exits = modal.querySelectorAll(".modal-exit");

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      modal.classList.add("open");
      body.classList.add("noscroll");
      exits.forEach(function (exit) {
        exit.addEventListener("click", function (event) {
          event.preventDefault();
          modal.classList.remove("open");
          body.classList.remove("noscroll");
        });
      });
    });
  });
}

// Team grid — WAI-ARIA "Tabs" pattern filtering the grid of cards
// client-side by team_type. One shared tabpanel (the grid itself) rather
// than a panel per tab, since the tabs only ever filter what's already
// been queried/rendered by PHP — see partials/flexible-team-grid.php.
function teamGridTabs() {
  const tablists = document.querySelectorAll(".team-tabs");

  tablists.forEach(function (tablist) {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const panel = document.getElementById(
      tabs[0].getAttribute("aria-controls")
    );

    if (!panel) return;

    const cards = Array.from(panel.querySelectorAll(".team-card"));

    function activate(tab) {
      tabs.forEach(function (t) {
        const isActive = t === tab;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-selected", isActive ? "true" : "false");
        t.tabIndex = isActive ? 0 : -1;
      });

      panel.setAttribute("aria-labelledby", tab.id);

      const category = tab.dataset.teamTab;
      cards.forEach(function (card) {
        const categories = (card.dataset.teamCategories || "").split(" ");
        card.hidden = !categories.includes(category);
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activate(tab);
      });

      tab.addEventListener("keydown", function (event) {
        let targetIndex = null;

        if (event.key === "ArrowRight" || event.key === "ArrowDown") {
          targetIndex = (index + 1) % tabs.length;
        } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
          targetIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === "Home") {
          targetIndex = 0;
        } else if (event.key === "End") {
          targetIndex = tabs.length - 1;
        }

        if (targetIndex !== null) {
          event.preventDefault();
          tabs[targetIndex].focus();
          activate(tabs[targetIndex]);
        }
      });
    });
  });
}

function fancyBox() {
  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });
}

// Blog reveal
function blogReveal() {
  if ($j(".event-content__text-more").length > 0) {
    const panels = document.querySelectorAll(".event-content__text-more");

    $j(panels).hide();

    if (typeof panels != "undefined" && panels != null) {
      const openPanel = (panel) => {
        panel.classList.add("open");

        $j(panel)
          .css("opacity", 0)
          .slideDown("fast")
          .animate({ opacity: 1 }, { queue: false, duration: "fast" });
      };

      const closePanel = (panel) => {
        panel.classList.remove("open");
        $j(panel)
          .css("opacity", 1)
          .slideUp("fast")
          .animate({ opacity: 0 }, { queue: false, duration: "fast" });
      };

      panels.forEach((panel) => {
        const trigger = document.querySelector(".read-more-link");
        const trigerSpan = document.querySelector(".read-more-link>span");

        trigger.onclick = (e) => {
          e.preventDefault();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 300);

          if (panel.classList.contains("open")) {
            closePanel(panel);
            trigger.classList.remove("open");
            trigerSpan.textContent = "Read more";
          } else {
            trigger.classList.add("open");
            panels.forEach((panel) => closePanel(panel));
            openPanel(panel);
            trigerSpan.textContent = "Read less";
          }
        };
      });
    } else {
      return;
    }
  }
}

function swiperTriggers() {
  if ($j(".blog-swiper").length > 0) {
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        swiperBlog();
      }
    }).observe(document.querySelector(".blog-swiper"));
  }

  if ($j(".flx-team-carousel__slider").length > 0) {
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        swiperTeam();
      }
    }).observe(document.querySelector(".flx-team-carousel__slider"));
  }

  if ($j(".flx-services.carousel .flx-services__slider").length > 0) {
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        swiperServices();
      }
    }).observe(document.querySelector(".flx-services.carousel .flx-services__slider"));
  }

  if ($j(".flx-case-studies__slider").length > 0) {
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        swiperCaseStudies();
      }
    }).observe(document.querySelector(".flx-case-studies__slider"));
  }

  if ($j(".flx-list-carousel__slider").length > 0) {
    new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        swiperListCarousel();
      }
    }).observe(document.querySelector(".flx-list-carousel__slider"));
  }
}

//// Utility functions ////

// DOM Ready

var DOMReady = function (callback) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", callback());
  } else if (document.attachEvent) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState != "loading") {
        callback();
      }
    });
  }
};

//// Let's go! ////
DOMReady(function () {
  // Global
  headerHideShow();
  burgerMenu();
  navDesktop();
  mobileNavDrilldown();
  smoothScroll();
  alertBar();
  fancyBox();
  playVideo();
  vanillaModal();
  flxStickyEl();
  siteSearch();

  anchorHighlight();

  // Flexible
  flxAccordion();
  flxAccordionTabs();
  flxProducts();
  flxFaqs();
  flxScrollingTextMedia();
  flxImageCarousel();
  flxInsightsNewsHover();
  flxInsightShare();
  flxFormEmbedConfirmation();
  flxFormEmbedFloatingLabels();
  flxDownloadGate();
  flxPartnerLogosMarqueeSpeed();
  footerHeadlineFit();
  flxServicesLottieIcons();
  headerStandardLottieIcon();
  swiperTestimonials();
  teamGridTabs();

  // Swipers
  if ($j(".hero-swiper").length > 0) swiperHero();
  if ($j(".swiper-marquee").length > 0) swiperMarquee();
  if ($j(".quicklinks-swiper").length > 0) swiperQuicklinks();
  // swiperTeam();
  if ($j(".related-blog__swiper").length > 0) swiperRel();

  // Videos
  headerHeroVideo();

  blogReveal();

  // Parallax
  heroParallax();
  headerParallax();
  imageParallax();

  // GSAP
  gsapAnimateScroll();

  $j(document).bind("gform_confirmation_loaded", function () {
    gsapAnimateScroll();
    console.log("form submitted");
  });

  swiperTriggers();
});

//// Preloader ///
const preloader = document.querySelector("#page-preloader");

document.addEventListener("DOMContentLoaded", function () {
  if (preloader.classList.contains("loaded")) {
    preloader.classList.remove("loaded");
  }
  setTimeout(function () {
    preloader.classList.add("loaded");
  }, PRELOADER_HOLD_MS);
});

// The Case studies / Insights & Learning / Events & Webinars listings'
// own AJAX refresh (ScrollTrigger.refresh() + gsapAnimateScroll() after
// every filter/load-more swap) now lives in assets/js/listing-filters.js,
// alongside the bespoke filtering that replaced Search & Filter Pro on
// those three pages.
